import styled from 'styled-components';

export const CardContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e8f0;
  box-shadow: 0px 19px 42px rgba(0, 27, 31, 0.08);
  @media only screen and (max-width: 1100px) {
    box-shadow: 0 0 0;
  }
  border-radius: 12px;
  padding: 1rem 1.5rem;
  .left {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #9da3b7;
  }
  .right {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
    text-align: right;

    span {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      text-align: right;
      color: #9DA3B7;
    }

    .edit {
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      color: #9da3b7;
      text-align: right;
      .link {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #1cbaf0;
        text-align: right;
        margin-left: 2px;
        cursor: pointer;
      }
    }

  @media only screen and (max-width: 1000px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
